// Modules
import axios from 'axios';
import QS from 'qs';
import _ from 'lodash';

// Axios config
axios.defaults.baseURL = '/';
// Serialize params using QS
axios.defaults.paramsSerializer = (params) => QS.stringify(params, { strictNullHandling: true });

let interceptor;

// UPDATE THIS TO EXTEND THE HEADER OBJECT

export function addHttpInterceptor(headers) {
  if (!_.isUndefined(interceptor)) axios.interceptors.request.eject(interceptor);

  interceptor = axios.interceptors.request.use((config) => {
    _.assign(config.headers, headers);

    return config;
  });
}



// WEBPACK FOOTER //
// ./app/services/http-config.js